/**
 * Define a class for Weapons
 */
export class Weapon {
    /**
     * The name of the weapon
     */
    name: string;

    /**
     * The base damage of the weapon before any stats are applied
     */
    baseDamage: number;

    price: number;
    internalName: string;

    constructor(name: string, damage: number, price: number, internalName: string) {
        this.name = name;
        this.baseDamage = damage;
        this.price = price;
        this.internalName = internalName;
    }
}
